import { render, staticRenderFns } from "./ObjectsCreateUrl.vue?vue&type=template&id=56ce3fdb&"
import script from "./ObjectsCreateUrl.vue?vue&type=script&lang=js&"
export * from "./ObjectsCreateUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports